import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FoodcourtService } from 'src/app/services/foodcourt.service';

@Component({
  standalone: false,
  selector: 'app-hide-vendor-review',
  templateUrl: './hide-vendor-review.component.html',
  styleUrls: ['./hide-vendor-review.component.scss'],
})
export class HidevendorreviewComponent implements OnInit {
  @Input() couponId: string;
  @Input() fromDetailsPage: any;
  @Input() fromListPage: any;
  @Input() foodCourtVendorId: any;
  @Input() reviewId: any;
  @Input() hideUnhideValue: any;
  @Input() reviewHideType: any;

  listCouponIds = [];

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private foodcourtService: FoodcourtService
  ) {
    this.myForm = this.formBuilder.group({
      deletedBy: '',
      userId: ''
    });
  }

  ngOnInit(): void { }

  hideVendorReview() {
    if (this.reviewHideType == 'bulk_hide') {
      this.foodcourtService
        .hideBulkReview(this.reviewId)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            location.reload();
          }
        });
      this.modal.dismiss();
    }
    if (this.reviewHideType == 'single_hide') {
      this.foodcourtService
        .hideSingleReview(this.reviewId)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            location.reload();
          }
        });
      this.modal.dismiss();
    }
  }
}
